import React from 'react';

const Icon = ({ width = '16', height = '17', fill = '#3F68E0', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 17" fill="none" {...other}>
            <rect x="3.333" y="3.955" width="10" height="10" rx="1.111" stroke={fill} />

            <path
                d="M8.332 10.066c.23 0 .417.187.417.417v.964a.01.01 0 0 1-.009.009h-.816c-.004 0-.008-.005-.008-.01v-.963c0-.23.186-.417.416-.417ZM6.806 6.733a.14.14 0 0 1 .139.139v1.944a.14.14 0 0 1-.14.14h-.277a.14.14 0 0 1-.14-.14V6.872a.142.142 0 0 1 .14-.14h.278Zm3.332.139a.14.14 0 0 1 .139.138v1.667a.139.139 0 0 1-.14.139h-.276a.14.14 0 0 1-.14-.139V7.01a.14.14 0 0 1 .14-.138h.277Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
